module.exports = __webpack_public_path__ + "img/luna.e1dfd2db.png";